import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { toast } from '@livable/saas-react-components';
import { Alert, Button, FormControlLabel, Radio, RadioGroup, TextareaAutosize, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { succeeded, unlessRefused } from '../requestOutcome';
import useSkipBillModalStyles from './styles';
const SkipBillContent = observer(_ref => {
  let handleClose = _ref.handleClose;
  const classes = useSkipBillModalStyles();
  const modalFooterClasses = useModalFooterStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const billingTab = (currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.billingTab) || {};
  const skipModal = billingTab.skipModal || {};
  const additionalSkipComment = skipModal.additionalSkipComment;
  const allocationCycleId = skipModal.allocationCycleId;
  const billingCycleId = skipModal.billingCycleId;
  const allocationTableSkipReason = skipModal.allocationTableSkipReason;
  const isDisabled = store.allocations.postTableApprovalAsync.inProgress || store.allocations.getAllocationPreviewAsync.inProgress;
  const isEdit = skipModal.isEdit;
  const isFromHistory = skipModal.isFromHistory;
  const otherSkipReason = skipModal.otherSkipReason;
  // A skip with no reason reads as "Reason not recorded" in the monthly recovery report.
  const isReasonMissing = !allocationTableSkipReason || allocationTableSkipReason === 'Other' && !(otherSkipReason !== null && otherSkipReason !== void 0 && otherSkipReason.trim());
  const propertyId = skipModal.propertyId;
  const setSkipModal = currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.billingTab.setSkipModal;
  const utilityId = skipModal.utilityId;
  const reasons = ['BillCopyIsNotAvailable', 'NoActiveResidents', 'OffCycle', 'Other'];
  const reasonTitle = {
    BillCopyIsNotAvailable: 'Bill copy not available',
    NoActiveResidents: 'No active residents',
    OffCycle: 'Off-Cycle',
    Other: 'Other'
  };
  const postTableApproval = async data => {
    const resp = await store.allocations.postTableApprovalAsync.run(data);
    return resp;
  };
  const handleSkip = async isSkipped => {
    handleClose();
    if (isSkipped) postTableApproval({
      additionalSkipComment,
      allocationTableSkipReason,
      allocationCycleId,
      billingCycleId,
      isApproved: null,
      isSkipped: true,
      otherSkipReason,
      propertyId,
      utilityId
    }).then(succeeded(store.allocations.postTableApprovalAsync)).then(() => billingTab.updateBillingSummaryTimestamp()).then(() => {
      var _store$homeDashboardS;
      return billingTab.addToPreviewQueue({
        billingCycleId,
        id: billingCycleId + propertyId,
        portfolioId: ((_store$homeDashboardS = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id) || '',
        propertyId
      });
    }).then(() => toast('success', {
      body: ['Bill skipped successfully']
    })).then(() => handleClose()).catch(unlessRefused(() => toast('error', ['Error in skipping bill'])));else postTableApproval({
      additionalSkipComment: null,
      allocationTableSkipReason: null,
      allocationCycleId,
      billingCycleId,
      isApproved: null,
      isSkipped: false,
      otherSkipReason: null,
      propertyId,
      utilityId
    }).then(succeeded(store.allocations.postTableApprovalAsync)).then(() => billingTab.updateBillingSummaryTimestamp()).then(() => {
      var _store$homeDashboardS2;
      return billingTab.addToPreviewQueue({
        billingCycleId,
        id: billingCycleId + propertyId,
        portfolioId: ((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.id) || '',
        propertyId
      });
    }).then(() => toast('success', {
      body: ['Bill unskipped successfully']
    })).then(() => handleClose()).catch(unlessRefused(() => toast('error', ['Error in skipping bill'])));
  };
  const handleAdditionalSkipComment = e => setSkipModal(_objectSpread(_objectSpread({}, skipModal), {}, {
    additionalSkipComment: e.target.value
  }));
  const handleOtherSkipReason = e => setSkipModal(_objectSpread(_objectSpread({}, skipModal), {}, {
    otherSkipReason: e.target.value
  }));
  const handleReasonChange = r => {
    if (isFromHistory) return;
    setSkipModal(_objectSpread(_objectSpread({}, skipModal), {}, {
      allocationTableSkipReason: r
    }));
  };
  const getTextClarify = () => {
    if (isFromHistory) return;else if (isEdit) return 'You can update the reason for skipping, or unskip the bill if it was done in error. If you choose to unskip, the bill will be reactivated and included back in the cycle.';else return 'Notice! You are about to skip this bill. This means the charges will not be applied or sent to the resident. Proceed only if this is intentional.';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    severity: isEdit ? 'info' : 'warning',
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, isEdit ? 'This bill was previously skipped' : 'Notice! You are about to skip your bill.'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, getTextClarify())), /*#__PURE__*/React.createElement("div", {
    className: classes.emptyForm
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.emptyFormList
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.emptyFormListTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, isFromHistory ? 'R' : 'Please select the r', "eason for skipping")), /*#__PURE__*/React.createElement(RadioGroup, {
    value: allocationTableSkipReason
  }, reasons.map(r => /*#__PURE__*/React.createElement("div", {
    key: r,
    className: classes.emptyFormListItem,
    onClick: () => handleReasonChange(r)
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: r,
    control: /*#__PURE__*/React.createElement(Radio, {
      disabled: isFromHistory
    })
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, reasonTitle[r]), r === 'Other' && /*#__PURE__*/React.createElement(TextField, {
    disabled: allocationTableSkipReason !== 'Other' || isFromHistory,
    fullWidth: true,
    onChange: handleOtherSkipReason,
    placeholder: t('Provide the reason'),
    value: otherSkipReason,
    variant: "outlined"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.emptyFormTextArea
  }, /*#__PURE__*/React.createElement(TextareaAutosize, {
    disabled: isFromHistory,
    minRows: 3,
    onChange: handleAdditionalSkipComment,
    placeholder: "Provide an additional comment (optional)",
    value: additionalSkipComment
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandartSmall
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose,
    variant: "text",
    'custom-attribute': '613-new-billing-module'
  }, t('buttons.cancel'))), isFromHistory ? null : /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, isEdit ? /*#__PURE__*/React.createElement(Button, {
    'custom-attribute': '696-new-billing-module',
    disabled: isDisabled,
    onClick: () => handleSkip(false),
    variant: "text"
  }, "Unskip bill") : null, /*#__PURE__*/React.createElement(Button, {
    disabled: isDisabled || isReasonMissing,
    onClick: () => handleSkip(true),
    variant: "contained",
    'custom-attribute': '614-new-billing-module'
  }, isEdit ? 'Save changes' : 'Skip bill'))))));
});
export default SkipBillContent;